<h1 class="flex a-baseline">
  <span>rlm</span>
  <div class="app-logo-image" [class.invert]="isLight$ | async"></div>
  <span>ves</span>
</h1>
